// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { DataTableCssOverrides } from "@steiner/MobiusOverrides/DataTable/DataTable";
import { xBaseTheme } from "@steiner/XDL/types";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const stickyMode = () => css`
    ${xScreen("lte", "sm")} {
        position: sticky;
        left: -5px;
        z-index: 2;
        background-clip: padding-box;
        background: inherit;
    }
`;

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            header: css`
                background: ${color("common.ui10")};
                padding: 5px 12px 6px 12px;
                border-bottom: 0;
                height: initial;
                line-height: 17px;
                font-size: 12px;
            `,
            head: css`
                background: ${color("common.ui10")};
                th:first-child {
                    ${stickyMode()}
                }
            `,
            cell: css`
                padding: 8px 12px;
                border-bottom: 0;
                height: initial;
                line-height: 22px;
                font-size: 14px;
                &:first-child {
                    ${stickyMode()}
                }

                & > ${StyledButton} {
                    ${TypographyStyle} {
                        font-size: 14px;
                        line-height: 22px;
                    }
                }
            `,
            row: css`
                background: ${color("common.white")};
            `,
            evenRow: css`
                background: ${color("common.ui2")};
            `,
        } as DataTableCssOverrides,
        headerTypographyProps: {
            mergeCss: true,
            size: 12,
            weight: "bold",
            color: "common.white",
            css: css`
                letter-spacing: 0;
            `,
        },
        cellTypographyProps: {
            mergeCss: true,
            size: 14,
            weight: "normal",
            css: css`
                letter-spacing: 0;
            `,
        },
        sortClickableProps: {
            css: css`
                width: 100%;
                height: 100%;
            `,
        },
        sortIconProps: {
            size: 12,
            color: "common.white",
            css: css`
                margin-left: 8px;
            `,
        },
        css: css`
            td[class^="DataTableCellBase"] {
                & > ${TypographyStyle}:empty:after {
                    content: "--";
                }
            }
        `,
    },
} as xBaseTheme["dataTable"];
